import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Tooltip, { POSITION, ALIGN } from 'gnos-tooltip'
import classnames from 'classnames'
import _ from 'lodash'

import MiniGraph from './components/MiniGraph'

import { hiddenHandler } from '../../../FixedColumn/helpers'

import { getArrowTrend, formatResultValue, getHigherIsBetterAsBool } from '../../helpers'
import { LOCALE_PREFIX } from '../../../../constants'

import './style.scss'

export default class Body extends Component {
    static propTypes = {
        activeRowIndex: PropTypes.string,
        compareYear: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        data: PropTypes.array,
        handleMouseLeaveRow: PropTypes.func.isRequired,
        handleRowHover: PropTypes.func.isRequired,
        isAdvanced: PropTypes.bool,
        openRows: PropTypes.array.isRequired,
        sampleYear: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        sectionsDefinition: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string.isRequired,
                rows: PropTypes.arrayOf(
                    PropTypes.shape({
                        prefix: PropTypes.string,
                        highlight: PropTypes.bool,
                        text: PropTypes.string.isRequired,
                        columnCode: PropTypes.string.isRequired,
                        indentationLevel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                        configuration: PropTypes.shape({
                            unit: PropTypes.string,
                            higherIsBetter: PropTypes.string,
                        }),
                    })
                ).isRequired,
            })
        ),
    }

    static defaultProps = {
        isAdvanced: false,
    }

    render() {
        const {
            sectionsDefinition,
            data,
            activeRowIndex,
            handleMouseLeaveRow,
            handleRowHover,
            sampleYear,
            compareYear,
            openRows,
            isAdvanced,
        } = this.props

        if (_.isEmpty(sectionsDefinition)) {
            return <div className={'empty-sections'} />
        }

        return (
            <div className={'result-column-body-content'}>
                {_.map(sectionsDefinition, (section, sectionIndex) => (
                    <div key={`${section.typeCode}-section`} className={'rc-section'}>
                        <div className={'ft-row section-title'} />
                        {_.map(_.get(section, 'rows', []), (row, index) => {
                            // Sample Year
                            const syValue = _.get(_(data).find({ year: sampleYear }), `values.${row.columnCode}`, null)
                            const syCurrency = _.get(_(data).find({ year: sampleYear }), `currency`, null)
                            // Compare Year
                            const cyValue = _.get(_(data).find({ year: compareYear }), `values.${row.columnCode}`, null)
                            const cyCurrency = _.get(_(data).find({ year: compareYear }), `currency`, null)

                            // Mini Graph Data
                            const graphData = _(data)
                                .take(5)
                                .map((x) => _.get(x, `values.${row.columnCode}`))
                                .reverse()
                                .value()
                            const graphCurrencies = _(data)
                                .take(5)
                                .map((x) => _.get(x, `currency`))
                                .reverse()
                                .value()
                            // Don't show graph if any of the years has different currency than the other years
                            const showGraph = _.every(graphCurrencies, (x) => x === graphCurrencies[0])

                            // Value
                            const resultValue =
                                !_.isNil(syValue) && !_.isNil(cyValue)
                                    ? Math.round(((syValue - cyValue) / Math.abs(syValue)) * -100) // The ratio is flipped (*-100)
                                    : null
                            // Arrow trend
                            const higherIsBetterString = _.get(row, 'configuration.higherIsBetter', null)
                            const flipped = _.isNil(higherIsBetterString)
                                ? null
                                : !getHigherIsBetterAsBool(higherIsBetterString)
                            const arrowTrend = getArrowTrend(resultValue, flipped)
                            // Don't show trend if the two years that are being compared have different currencies
                            const showTrend = syCurrency === cyCurrency

                            // If there's no trend and no graph show info icon
                            // Only show the info icon on the first row
                            if (!showTrend && !showGraph && sectionIndex === 0 && index === 0) {
                                return (
                                    <div
                                        key={`${row.columnCode}-row`}
                                        onMouseOver={() => handleRowHover(`${sectionIndex}-${index}`)}
                                        onMouseLeave={() => handleMouseLeaveRow()}
                                        onFocus={() => handleRowHover(`${sectionIndex}-${index}`)}
                                        className={classnames(
                                            'ft-row',
                                            'rc-row',
                                            row.highlight && 'sum-row',
                                            activeRowIndex === `${sectionIndex}-${index}` && 'active',
                                            'empty-trend'
                                        )}
                                    >
                                        <Tooltip
                                            id={`results-column-empty-trend-tooltip-${sectionIndex}-${index}`}
                                            content={<FormattedMessage id={`${LOCALE_PREFIX}.emptyTrend`} />}
                                            position={POSITION.TOP}
                                            align={ALIGN.CENTER}
                                        >
                                            <span className={'info-icon'} />
                                        </Tooltip>
                                    </div>
                                )
                            }

                            return (
                                (!isAdvanced || (isAdvanced && !hiddenHandler(row, openRows))) && (
                                    <div
                                        key={`${row.columnCode}-row`}
                                        onMouseOver={() => handleRowHover(`${sectionIndex}-${index}`)}
                                        onMouseLeave={() => handleMouseLeaveRow()}
                                        onFocus={() => handleRowHover(`${sectionIndex}-${index}`)}
                                        className={classnames(
                                            'ft-row',
                                            'rc-row',
                                            row.highlight && 'sum-row',
                                            activeRowIndex === `${sectionIndex}-${index}` && 'active'
                                        )}
                                    >
                                        {showTrend && (
                                            <div className={`rc-trend-arrow-container arrow-${arrowTrend}`} />
                                        )}
                                        {showTrend && (
                                            <div className={'rc-value-container'}>
                                                <span>{formatResultValue(resultValue)}</span>
                                            </div>
                                        )}
                                        {showGraph && (
                                            <div className={'rc-mini-graph'}>
                                                <MiniGraph data={graphData} />
                                            </div>
                                        )}
                                    </div>
                                )
                            )
                        })}
                    </div>
                ))}
            </div>
        )
    }
}
